import { Stack } from "@mui/material";
import urls from "api/urls";
import { Button } from "components/ButtonNew";
import { SingleBuildingContext } from "features/dt-basic-setup/single-building/context/AddSingleBuildingContext";
import { STEP } from "features/dt-basic-setup/single-building/model/constants";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";

export const SupportChatButton = () => {
  const { t } = useTranslation();
  const { stepNo } = useContext(SingleBuildingContext);
  if (stepNo >= STEP.final) return;
  return (
    <Stack className="mt-10 w-full justify-end">
      <a href={`mailto:${urls.user.supportEmail}`}>
        <Button onClick={() => {}} size="sm" variant="secondary">
          {t("AddBuilding.actionButtons.supportChatButtonText")}
        </Button>
      </a>
    </Stack>
  );
};
